'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.directive("tlModuleAideSubvention", function () {
  return {
    restrict: "E",
    replace: true,
    scope: true,
    template: "<span tl-tooltip=\"Subventions\" class=\"mr-s module-aide-subvention\">S</span>"
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/modules/tl-module-aide-subvention.js
// module id = 2854
// module chunks = 13